import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { RT_API_DEMO } from 'src/store/ActionTypes';
import * as api from 'src/store/api';
import * as actions from '../actions/rt_api_list';

/**
 *
 * @return {CS}
 */
const selectConfig = (state) => state.rtApiDemo.config;

/**
 * fetchConfig - flow control for fetching a realtime config
 * @param {{type: string, payload: string }} action
 * @returns {Generator<*, void, *>}
 */
function* fetchConfig(action) {
  try {
    // NOTE: Check if the config has been set from the list page, and matches the requested config
    const { payload: configId } = action;
    /** @type {CS} config */
    let config = yield select(selectConfig);
    if ([null, undefined].includes(config)) {
      config = yield call(api.fetchRtConfig, configId);
    }
    if (config.score_type === 'static') config.config_metadata.model = { name: 'Test Environment', typeDetail: 'TEST' };
    else if (!config.config_metadata.model_id) {
      config.config_metadata.model = {
        id: -1 * Math.random(),
        name: config.config_metadata.name || 'CUSTOM MODEL',
        typeDetail: config.config_metadata.type_detail || 'CUSTOM TYPE',
        dataModelType: config.config_metadata.data_model_type || 'CLASSIFIER',
      };
    } else config.config_metadata.model = yield call(api.fetchModel, config.config_metadata.model_id);
    yield put({
      type: RT_API_DEMO.FETCH_CONFIG_SUCCEEDED,
      payload: config,
    });
  } catch (err) {
    yield put({
      type: RT_API_DEMO.FETCH_CONFIG_FAILURE,
      payload: err.message,
    });
  } finally {
    yield delay(500);
    yield put(actions.unset('fetchConfigError'));
  }
}

/**
 * submitDemo - flow control for demo request
 * @param {{type: string, payload: DemoPayload }} action
 * @returns {Generator<*, void, *>}
 */
function* submitDemo(action) {
  try {
    const { payload: data } = action;
    const { id: configId } = yield select(selectConfig);
    const response = yield call(api.demoRealTimeApiV2, configId, data);
    yield put({
      type: RT_API_DEMO.SUBMIT_DEMO_SUCCEEDED,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: RT_API_DEMO.SUBMIT_DEMO_FAILURE,
      payload: err.message,
    });
  } finally {
    yield delay(500);
    yield put(actions.unset('demoResponseError'));
  }
}

function* fetchConfigSaga() {
  yield takeLatest(RT_API_DEMO.FETCH_CONFIG, fetchConfig);
}

function* submitDemoSaga() {
  yield takeLatest(RT_API_DEMO.SUBMIT_DEMO, submitDemo);
}

export default [fetchConfigSaga(), submitDemoSaga()];
